import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Stack,
  styled,
  Typography,
} from '@mui/material';

import { ImagePreview } from '../ImagePreview';
import { VideoPreview } from '../VideoPreview';

export const AdditionalInfoTypographyStyled = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[4],
  display: 'inline-flex',
  alignItems: 'center',
  gap: theme.spacing(0.5),
}));

export const ExclamationIconStyled = styled(FontAwesomeIcon)(({ theme }) => ({
  color: theme.palette.red[1],
}));

export const FileInfoStack = styled(Stack)({
  width: '100%',
  marginLeft: 16,
  marginRight: 8,
  marginBottom: 8,
});

export const ImagePreviewStyled = styled(ImagePreview)(({ theme }) => ({
  width: theme.spacing(34.25),
  height: theme.spacing(19.25),
  borderRadius: 0,
}));

export const InfoIconStyled = styled(FontAwesomeIcon)(({ theme }) => ({
  color: theme.palette.grey[4],
  fontSize: theme.spacing(1.5),
}));

export const PlayCircleIconStyled = styled(FontAwesomeIcon)(({ theme }) => ({
  color: theme.palette.blue[12],
}));

export const RemoveIconStyled = styled(FontAwesomeIcon)(({ theme }) => ({
  width: theme.spacing(2),
  height: theme.spacing(2),
  color: theme.palette.grey[6],
}));

export const TimerIconStyled = styled(FontAwesomeIcon)(({ theme }) => ({
  fontSize: theme.spacing(2.25),
}));

export const TitleStyled = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontWeight: 700,
}));

export const VideoPreviewStyled = styled(VideoPreview)(({ theme }) => ({
  width: theme.spacing(34.25),
  height: theme.spacing(19.25),
  borderRadius: 0,
}));
